<div
  class="ws-page-subheader"
  *ngIf="navigationState$ | async as navState"
  [class.ws-page-subheader--stacked]="
    (navState.showBreadcrumb && (navState.showSubtitle || !!navState.subtitle)) ||
    navState.stackedSubheader
  "
>
  <!-- Back Button Section -->
  <div class="back-button" *ngIf="navState.showBackButton">
    <button (click)="goBack()"><mat-icon>arrow_back</mat-icon> {{ 'Back' | translate }}</button>
  </div>

  <!-- Breadcrumb Section -->
  <div class="breadcrumb" *ngIf="navState.showBreadcrumb">
    <ng-container
      *ngIf="navState.breadcrumb && navState.breadcrumb.length > 0; else defaultBreadcrumb"
    >
      <a [routerLink]="['/']" class="home-icon">
        <mat-icon>home</mat-icon>
      </a>
      <span> / </span>
      <ng-container *ngFor="let item of navState.breadcrumb; let last = last">
        <!-- <a *ngIf="!last" [href]="item.link">{{ item.label }}</a> -->
        <a [href]="item.link" *ngIf="!last" style="margin: 0 5px;">{{ item.label }}</a>
       <span *ngIf="last">{{ item.label }}</span>
        <span *ngIf="!last"> / </span>
      </ng-container>
    </ng-container>

    <!-- Default Breadcrumb (Home icon and title when breadcrumb is empty) -->
    <ng-template #defaultBreadcrumb>
      <a [routerLink]="['/']" class="home-icon">
        <mat-icon>home</mat-icon>
      </a>
    </ng-template>
  </div>

  <!-- Icon and Title Section (hidden when feature page owns the title, e.g. ecommerce wizard) -->
  <div class="subheader-info" *ngIf="navState.showSubtitle || !!navState.subtitle">
    <mat-icon *ngIf="navState.subTitleIcon" class="subheader-icon">{{ navState.subTitleIcon }}</mat-icon>
    <div class="subtitle-section">
      <span class="subtitle" [wsTooltip]="navState.tooltip || ''">{{ navState.subtitle }}</span>
    </div>
  </div>
</div>
